module.exports = __webpack_public_path__ + "static/WORLD1-902feb51332bd5b9140b0213ddd0ff21.jpg";